<template>
    <v-card variant="flat">
        <v-toolbar flat>
            <v-toolbar-title>{{ t('Asistencia') }}</v-toolbar-title>
            <v-btn color="primary" @click="showScanner" class="ma-2">
                QR Escàner
            </v-btn>
            <ExportExcel :dataItems="asistencia" />
        </v-toolbar>
        <v-text-field class="ma-4" v-model="search" label="Cerca" prepend-inner-icon="mdi-magnify" single-line
            variant="outlined" hide-details></v-text-field>
        <v-data-table-virtual :headers="headers" :items="asistencia" :search="search" :loading="loading">
            <template v-slot:loading>
                <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
        </v-data-table-virtual>
    </v-card>
    <v-dialog v-model="scannerDialog" max-width="500px">
        <v-card>
            <AdminQR></AdminQR>
        </v-card>
    </v-dialog>
</template>


<script setup>
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { axios } from '../axios';
import AdminQR from './AdminQR.vue';

// 1. Imports de Pinia
import ExportExcel from './ExportExcel.vue';

const scannerDialog = ref(false);
const { t } = useI18n();

const search = ref('');
const asistencia = ref([]);

const headers = ref([
    { title: t('Email'), key: 'qr_email' },
    { title: t('Nombre'), key: 'qr_first_name' },
    { title: t('Apellidos'), key: 'qr_last_name' },
    { title: t('Rol'), key: 'rol' },
    { title: t('AFOS'), key: 'curso_afos' },
    { title: t('ID Curso'), key: 'curso' },
    { title: t('Entrada'), key: 'entry_at_pretty' },
    { title: t('Salida'), key: 'exit_at_pretty' },
    { title: t('Duración'), key: 'duracion' },
]);
const loading = ref(false);

function showScanner() {
    scannerDialog.value = true;
}

function fetchAsistencia() {
  loading.value = true
  axios.get('asistencia/')
    .then(response => {
      asistencia.value = response.data.map(row => ({
        ...row,
        entry_at_pretty: formatDateTime(row.entry_at),
        exit_at_pretty: formatDateTime(row.exit_at),
      }))
    })
    .catch(error => {
      console.error('Error fetching asistencia:', error)
    })
    .finally(() => {
      loading.value = false
    })
}

function formatDateTime(value) {
  if (!value) return ''
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return value

  return new Intl.DateTimeFormat('ca-ES', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  }).format(d)
}

onMounted(() => {
    fetchAsistencia();
});
</script>
